export const failureCardArray = [
    {
        title: 'DASHBOARD_COMPONENT_IS_MISSING',
        propertyPath: '/data/components',
        type: 'blocker',
        navigateToTab: () => { },
        page: 'components',
    },
    {
        title: 'APP_ICON_IS_MISSING',
        propertyPath: '/data/appListings',
        type: 'blocker',
        navigateToTab: () => { },
        page: 'basicInfo',
    },
    {
        title: 'APP_TEASER_IS_MISSING',
        propertyPath: '/data/appListings',
        type: 'blocker',
        navigateToTab: () => { },
        page: 'appListings',
    },
    {
        title: 'OAUTH_DATA_IS_MISSING',
        propertyPath: '/authData',
        type: 'blocker',
        navigateToTab: () => { },
        page: 'oauth',
    },
];
export const recCardArray = [
    {
        title: 'APP_SHOULD_PROVIDE_A_YOUTUBE_VIDEO',
        propertyPath: '/data/appListings',
        type: 'recommendation',
        navigateToTab: () => { },
        page: 'appListings',
    },
    {
        title: 'APP_SHOULD_PROVIDE_A_PROMOTIONAL_BANNER',
        propertyPath: '/data/appListings',
        type: 'recommendation',
        navigateToTab: () => { },
        page: 'appListings',
    },
];
export const failuresAndRecs = {
    appPropertiesValidity: [
        {
            id: '',
            appId: '0223b754-8074-48ec-8676-c52cd1d943f9',
            version: 'latest',
            propertyPath: '/data/components',
            dataFormat: undefined,
            failures: ['DASHBOARD_COMPONENT_IS_MISSING'],
            recommendations: [],
        },
        {
            id: '',
            appId: '0223b754-8074-48ec-8676-c52cd1d943f9',
            version: 'latest',
            propertyPath: '/data/appListings',
            dataFormat: undefined,
            failures: ['APP_ICON_IS_MISSING', 'APP_TEASER_IS_MISSING'],
            recommendations: [
                'APP_SHOULD_PROVIDE_A_YOUTUBE_VIDEO',
                'APP_SHOULD_PROVIDE_A_PROMOTIONAL_BANNER',
            ],
        },
        {
            id: '',
            appId: '0223b754-8074-48ec-8676-c52cd1d943f9',
            version: 'latest',
            propertyPath: '/authData',
            dataFormat: undefined,
            failures: ['OAUTH_DATA_IS_MISSING'],
            recommendations: [],
        },
    ],
};
export const mockSideBarLinks = {
    dashboard: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/dashboard',
    components: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/build/components',
    oauth: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/build/oauth',
    permissions: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/build/permissions',
    addPermission: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/build/permission/add',
    webhooks: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/build/webhooks',
    webhooksLogs: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/manage/webhooks-logger',
    addWebhook: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/build/webhook/add',
    basicInfo: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/market/info/basic-info',
    assets: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/market/info/assets',
    pricing: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/market/info/pricing',
    getFound: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/market/info/contact',
    appAudience: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/market/info/installation',
    contactInfo: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/manage/contact-information',
    translations: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/localization',
    oldTranslations: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/marketing/localization',
    versionGuidelines: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/guidelines',
    versions: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/versions',
    internalVersions: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/updates-logs',
    reviews: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/manage/reviews',
    statistics: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/manage/stats',
    payouts: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/payouts',
    coupons: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/manage/coupons',
    teamMembers: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/manage/team',
    companyInfo: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/manage/business-account',
    oldJson: '/my-apps/0223b754-8074-48ec-8676-c52cd1d943f9/manage/old-json',
};
//# sourceMappingURL=mockData.js.map